// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // URL_API: 'https://7fca-2603-9000-ba00-2fd1-4067-3207-7522-4d27.ngrok-free.app/',
  //URL_API: 'https://dev.api.onsight.pro/',
  URL_API: 'https://api.onsight.avanzandoweb.com/',
  // URL_API: 'https://inversiones.elim.api.onsight.pro/',
  // URL_API: 'https://0aa6-2603-9000-ba00-2fd1-85a2-d206-ed64-604c.ngrok-free.app/',
  show_lang_base: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

